import {
  getGetMacroTipiOnereQueryOptions,
  getMacroTipiOnere,
} from '@framework/api-client/api/inquiries/macro-tipi-onere-controller/macro-tipi-onere-controller.ts';
import { type MacroTipoOnereDTO } from '@framework/api-client/api/inquiries/schemas/macroTipoOnereDTO.ts';
import {
  AsyncSelectInput,
  type IBaseAsyncSelectInputProps,
} from '@framework/form/inputs/AsyncSelectInput.tsx';
import { useMemo } from 'react';

export interface IMacroBurdenTypeSelectInputProps
  extends IBaseAsyncSelectInputProps {
  // Otteniamo Macro Tipo Oneri AgID
  isAgid?: boolean;
}

export function MacroBurdenTypeSelectInput(
  props: IMacroBurdenTypeSelectInputProps,
) {
  const { isAgid, ...otherProps } = props;

  const initialParams = useMemo(
    () => ({
      // Se isAgid è null o undefined, non includere il parametro nella query
      ...(isAgid != null && { isAgid }),
    }),
    [isAgid],
  );

  return (
    <AsyncSelectInput
      {...otherProps}
      initialParams={initialParams}
      queryFn={getMacroTipiOnere}
      queryOptions={getGetMacroTipiOnereQueryOptions}
      searchByField="denominazione"
      asOption={(type: MacroTipoOnereDTO) => ({
        value: type.id!,
        label: type.denominazione!,
      })}
    />
  );
}
